import { Injectable } from '@angular/core';
import { User } from '../../models/login/user';
import { Http, Response, RequestOptions, Request, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs';
import 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { DebugElement } from '@angular/core/src/debug/debug_node';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import 'rxjs/add/Observable/throw';
import 'rxjs/add/operator/toPromise';
import { global } from '../../models/global';
import { Body } from '@angular/http/src/body';
import { InventoryData, MaterialDamaged } from 'src/app/Models/InventoryManagement/inventory-data';

@Injectable({
    providedIn : 'root'
})
export class InventoryService {
    ROOT_URL : string = "";
    constructor(private http : Http) {
        let g : global = new global();
        this.ROOT_URL = g.getApiUrl();
    }

    inventoryDetails(name : string, state : string, type : string, brand : string, crop : string, language : string,
        location : string) : Observable<any> {
        let _body = {
            "RMHID" : localStorage.getItem('mcmt_userId'),
            "RMHName" : name,
            "State" : state,
            "JobType" : type,
            "Brand" : brand,
            "Crop"  : crop,
            "Language"  : language,
            "WHLocation"  : location
          }
          let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'POST',
            url : this.ROOT_URL + "/api/Inventory/InventoryManagementDetails",
            headers : headers,
            body : _body
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                return res.json();
            });

    }

    inventoryFilters() : Observable<any> {
        let userID = localStorage.getItem('mcmt_userId');
        let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'GET',
            url : this.ROOT_URL + "/api/Inventory/InventoryManagementFilter?UserID="+userID,
            headers : headers
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                return res.json();
            });

    }

    inventoryUpdate(detail : MaterialDamaged[]) : Observable<any> {
        let _body = {
            "UserID" : localStorage.getItem('mcmt_userId'),
            "Data" : detail
          }
          let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId') });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'POST',
            url : this.ROOT_URL + "/api/Inventory/InventoryManagementUpdate",
            headers : headers,
            body : _body
        })
        
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                return res.json();
            });

    }

    downloadInventoryExcel(name : string, state : string, type : string, brand : string, crop : string, language : string,
        location : string) : Observable<any> {
        let _body = {
            "RMHID" : localStorage.getItem('mcmt_userId'),
            "RMHName" : name,
            "State" : state,
            "JobType" : type,
            "Brand" : brand,
            "Crop"  : crop,
            "Language"  : language,
            "WHLocation"  : location
          }       
            let headers = new Headers({ 'Content-Type': 'application/json;charset=utf-8', 'Authorization':'Bearer '+ localStorage.getItem('mcmt_token'), 'UserID': localStorage.getItem('mcmt_userId')  });
        let requestoptions : RequestOptions = new RequestOptions({
            method : 'POST',
            url : this.ROOT_URL + "/api/Inventory/DownloadExcel",
            headers : headers,
            body : _body,
            responseType : ResponseContentType.Blob
        })
        return this.http.request(new Request(requestoptions))
            .map((res : Response) => {
                var blob = new Blob([res.blob()], { type: 'xlsx' })
                return blob;
            });

    }
}
